import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { FloatingChatComponent } from './floating-chat.component';
import { LearningAssistantComponent } from './learning-assistant/learning-assistant.component';
import { SupportWidgetComponent } from './support-widget/support-widget.component';
import { TutorAssistantComponent } from './tutor-assistant/tutor-assistant.component';
import { ChatAIService } from '../../services/chat-ai.service';
import { TutorAiService } from '../../services/tutor-ai.service';
import { AppCommon2Module } from '../../common2/common.module';

@NgModule({
    declarations: [
        FloatingChatComponent,
        LearningAssistantComponent,
        SupportWidgetComponent,
        TutorAssistantComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        AppCommon2Module
    ],
    providers: [ChatAIService, TutorAiService],
    exports: [FloatingChatComponent]
})
export class FloatingChatModule { }
